import { Link } from "react-router-dom";
import { useSuspensePosts, useSuspensePostsRecent } from "../calendar/usePosts";
import { Button } from "../components/Button";
import { Card } from "../components/Card";
import { GenericErrorBoundary } from "../components/GenericError";
import { StatusPlaceholder } from "../components/StatusPlaceholder";
import { LinkGen } from "../LinkGen";
import { Svg } from "../svg";
import { ListEvents } from "./ListEvents";

export function RecentlyPublishedCard() {
	return (
		<Card>
			<Card.Header>
				Recently Published
				<Link to={LinkGen.Calendar()}>Go to calendar</Link>
			</Card.Header>

			<Card.Body>
				<GenericErrorBoundary>
					<RecentlyPublishedBody />
				</GenericErrorBoundary>
			</Card.Body>
		</Card>
	);
}

function RecentlyPublishedBody() {
	const recentIDs = useSuspensePostsRecent();
	const recentPosts = useSuspensePosts(recentIDs.IDs);

	if (recentPosts?.length === 0) {
		return (
			<StatusPlaceholder
				label="No published content"
				sublabel="Go to calendar to schedule content"
				image={Svg.PublishPost}
			>
				<Button icon="arrow_forward" size="sm">
					Calendar
				</Button>
			</StatusPlaceholder>
		);
	}

	return <ListEvents posts={recentPosts ?? []} />;
}
